export default __webpack_public_path__ + "static/media/1.a2f301c4.jpg";